import React, { Component } from 'react';

import Errors from '../../Errors';
import { Form, Label, Input, Button } from '../../Form';

class Practice extends Component {
  constructor(...props) {
    super(...props);

    this.state = {
      isValid: false,
      isBusy: false,
      errors: undefined
    };
  }

  save(body) {
    this.setState({ isBusy: true });

    this.props.store(body, () => {
      this.props.save().catch(({ data: errors }) => this.setState({ errors }));
    });
  }

  render() {
    const { isValid, errors } = this.state;
    const { previous, data, translate } = this.props;

    return (
      <Form
        ref={form => (this.form = form)}
        onValidationChange={valid => this.setState({ isValid: valid })}
        onSubmit={({ body }) => this.save(body)}
      >
        <Errors errors={errors} />
        <Label text={translate('register.account.email')} />
        <Input
          rules={['required', 'email']}
          name="email"
          defaultValue={data.email}
        />

        <Label text={translate('register.account.password')} />
        <Input
          type="password"
          rules={['required']}
          name="password"
          inputRef={input => (this.passwordField = input)}
          defaultValue={data.password}
        />
        <Button solid className="Form__Button" disabled={!isValid}>
          {translate('register.account.create')}
        </Button>
        <Button transparant className="Form__Button" onClick={() => previous()}>
          {translate('register.previous')}
        </Button>
      </Form>
    );
  }
}

export default Practice;
